import { useMutation } from 'react-query';
import { queryClient } from '../config/queryClient';
import { chatgenieAPI } from '../services/chatgenieAPI';
import { URL_API } from '../constants';
import queryKeys from '../constants/queryKeys';

const updateSummary = data =>
  chatgenieAPI
    .instance({
      method: 'POST',
      url: `${URL_API}/api/inbox/actions/summary`,
      data
    })
    .then(res => res.data.data);

const useSummary = ({ ticketId }) => {
  const { mutate, isLoading, error } = useMutation(
    summary =>
      updateSummary({
        ticketId,
        summary
      }),
    {
      onSuccess: newTicket => {
        queryClient.setQueryData([queryKeys.GET_TICKET, ticketId], old => ({
          ...old,
          summary: newTicket.summary
        }));
      }
    }
  );

  return {
    errorMessage: error?.response?.data?.message,
    isLoading,
    updateSummary: mutate
  };
};

export default useSummary;
